import { Mortgage, MortgageFields, MortgageProgramTable, MortgageBanner } from '../../components/Mortgage';
import * as React from 'react';
import { MortgageProgramModal } from '../../components/Mortgage/components/MortgageProgramModal';
import { useMortgage } from './hooks/useMortgage';
import { MortgageOffersNotFound } from '../../components/Mortgage/components/MortgageOffersNotFound';

export const MortgageContainer: React.FC = () => {
  const {
    programs,
    fields,
    selectedProgram,
    selectProgram,
    resetSelectedProgram,
    trackMortgageButtonClick,
    trackNoOfferClick,
    trackMortgageModalButtonClick,
    trackMortgageOnlineLabelClick,
  } = useMortgage();

  return (
    <>
      <Mortgage
        title="Купить в ипотеку"
        fields={<MortgageFields {...fields} />}
        programs={
          programs.length ? (
            <MortgageProgramTable
              items={programs}
              onProgramSelect={selectProgram}
              onLabelClick={trackMortgageOnlineLabelClick}
            />
          ) : (
            <MortgageOffersNotFound onMortgageLinkClick={trackNoOfferClick} />
          )
        }
        banner={<MortgageBanner onButtonClick={trackMortgageButtonClick} />}
      />
      {selectedProgram && (
        <MortgageProgramModal
          onClose={resetSelectedProgram}
          onMortgageButtonClick={trackMortgageModalButtonClick}
          {...selectedProgram}
        />
      )}
    </>
  );
};
